import React from 'react';

import { Text, TextProps } from '@mantine/core';
import { characterCountColor } from 'shared/utils/form-validators';

interface CharacterCounterProps extends TextProps {
  length: number;
  maxLength: number;
}

export function CharacterCounter({ length, maxLength, ...textProps }: CharacterCounterProps) {
  return (
    <Text mt={3} size="xs" {...textProps} color={characterCountColor(maxLength, length)}>
      {length}/{maxLength}
    </Text>
  );
}
